import { useState } from "react";

export default function StorageSettings({ user, onSignOut, onClose, syncLabel, onVerifyDriveFiles }) {
  const [verifying, setVerifying] = useState(false);

  const handleVerify = async () => {
    setVerifying(true);
    try { await onVerifyDriveFiles?.(); }
    finally { setVerifying(false); }
  };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, zIndex:400, background:"rgba(0,0,0,.85)", backdropFilter:"blur(14px)", display:"flex", alignItems:"center", justifyContent:"center", animation:"fade-in .2s ease", fontFamily:"'DM Sans',sans-serif", padding:"20px" }}>
      <div onClick={e=>e.stopPropagation()} style={{ width:"100%", maxWidth:"440px", background:"#0b0b1c", border:"1px solid rgba(255,255,255,.08)", borderRadius:"16px", boxShadow:"0 50px 120px rgba(0,0,0,.9)", animation:"panel-in .25s ease", overflow:"hidden" }}>
        <div style={{ padding:"20px 24px 16px", borderBottom:"1px solid rgba(255,255,255,.05)", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div>
            <p style={{ fontFamily:"'Bebas Neue'", fontSize:"22px", letterSpacing:".15em", color:"#E8FF47" }}>ACCOUNT</p>
            <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.25)", letterSpacing:".1em", textTransform:"uppercase", marginTop:"3px" }}>Google Drive storage</p>
          </div>
          <button onClick={onClose} style={{ width:"30px", height:"30px", borderRadius:"50%", border:"1px solid rgba(255,255,255,.1)", background:"transparent", color:"rgba(255,255,255,.4)", cursor:"pointer", fontSize:"13px" }}>×</button>
        </div>
        <div style={{ padding:"20px 24px 28px", display:"flex", flexDirection:"column", gap:"14px" }}>
          {user && (
            <div style={{ padding:"16px", borderRadius:"12px", background:"rgba(255,255,255,.03)", border:"1px solid rgba(255,255,255,.07)", display:"flex", alignItems:"center", gap:"14px" }}>
              {user.picture ? (
                <img src={user.picture} alt="" style={{ width:"40px", height:"40px", borderRadius:"50%", flexShrink:0 }}/>
              ) : (
                <div style={{ width:"40px", height:"40px", borderRadius:"50%", background:"rgba(232,255,71,.1)", border:"1px solid rgba(232,255,71,.2)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <span style={{ fontFamily:"'Bebas Neue'", fontSize:"18px", color:"#E8FF47" }}>{(user.name||user.email||"?")[0].toUpperCase()}</span>
                </div>
              )}
              <div>
                {user.name && <p style={{ fontFamily:"'DM Sans'", fontSize:"13px", color:"rgba(255,255,255,.8)", fontWeight:"500" }}>{user.name}</p>}
                <p style={{ fontFamily:"'DM Mono'", fontSize:"10px", color:"rgba(255,255,255,.35)", marginTop:"2px" }}>{user.email}</p>
              </div>
            </div>
          )}

          {/* Sync status */}
          <div style={{ padding:"14px 16px", borderRadius:"10px", background:"rgba(232,255,71,.04)", border:"1px solid rgba(232,255,71,.12)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"6px" }}>
              <p style={{ fontFamily:"'DM Mono'", fontSize:"10px", color:"#E8FF47", letterSpacing:".08em" }}>Drive sync</p>
              <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(232,255,71,.6)" }}>{syncLabel || "Not synced yet"}</p>
            </div>
            <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.3)", lineHeight:"1.7" }}>
              Your library is stored in <span style={{ color:"rgba(232,255,71,.5)" }}>oracle-data.json</span> on your Drive. ORACLE also saves JPEG backups to <span style={{ color:"rgba(232,255,71,.5)" }}>oracle-images/</span> that you can view in Drive.
            </p>
          </div>

          {/* Drive note  -  how deletion works */}
          <div style={{ padding:"14px 16px", borderRadius:"10px", background:"rgba(255,255,255,.02)", border:"1px solid rgba(255,255,255,.06)" }}>
            <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.5)", letterSpacing:".08em", textTransform:"uppercase", marginBottom:"8px" }}>About Drive & your library</p>
            <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.28)", lineHeight:"1.8" }}>
              Deleting a file from <span style={{ color:"rgba(232,255,71,.4)" }}>oracle-images/</span> in Drive only removes the backup copy  -  your image stays in ORACLE. To fully remove an image, use the Delete button inside ORACLE.
            </p>
            <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.28)", lineHeight:"1.8", marginTop:"6px" }}>
              If you've deleted files from Drive and want to clean up your library to match, use the button below.
            </p>
          </div>

          {/* Verify Drive files */}
          <button
            onClick={handleVerify}
            disabled={verifying}
            style={{ padding:"11px", borderRadius:"10px", border:"1px solid rgba(255,255,255,.1)", background:"rgba(255,255,255,.03)", color:verifying?"rgba(255,255,255,.25)":"rgba(255,255,255,.5)", fontFamily:"'DM Mono'", fontSize:"10px", letterSpacing:".08em", textTransform:"uppercase", cursor:verifying?"not-allowed":"pointer", transition:"all .15s" }}
          >
            {verifying ? "Checking Drive..." : "↻ Verify & sync Drive files"}
          </button>

          <button onClick={onSignOut} style={{ padding:"12px", borderRadius:"10px", border:"1px solid rgba(255,100,100,.2)", background:"rgba(255,60,60,.04)", color:"rgba(255,120,120,.7)", fontFamily:"'DM Mono'", fontSize:"10px", letterSpacing:".08em", textTransform:"uppercase", cursor:"pointer" }}>Sign out</button>
          <button onClick={onClose} style={{ padding:"10px", borderRadius:"10px", border:"1px solid rgba(255,255,255,.06)", background:"transparent", color:"rgba(255,255,255,.2)", fontFamily:"'DM Mono'", fontSize:"10px", letterSpacing:".08em", textTransform:"uppercase", cursor:"pointer" }}>Close</button>
        </div>
      </div>
    </div>
  );
}
